import { Box } from "@mui/material";

export const BadgeBox = ({ shortLabel, fullLabel }) => (
  <Box
    sx={{
      display: "inline-block",
      minWidth: 36,
      maxWidth: 180,
      width: "auto",
      position: "relative",
      fontWeight: 700,
      fontSize: 14,
      color: "#1976d2",
      backgroundColor: "#e3f2fd",
      padding: "4px 8px",
      borderRadius: 1,
      cursor: "pointer",
      overflow: "hidden",
      transition:
        "min-width 0.3s cubic-bezier(0.4,0,0.2,1), max-width 0.3s cubic-bezier(0.4,0,0.2,1)",
      minWidth: 36,
      maxWidth: 48,
      "&:hover": {
        minWidth: 140,
        maxWidth: 180,
      },
      "&:hover .short-label": {
        opacity: 0,
        transform: "translateY(-8px)",
      },
      "&:hover .full-label": {
        opacity: 1,
        transform: "translateY(0)",
      },
    }}
  >
    <Box
      className="short-label"
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 1,
        transition: "opacity 0.2s, transform 0.2s",
        zIndex: 1,
        whiteSpace: "nowrap",
      }}
    >
      {shortLabel}
    </Box>
    <Box
      className="full-label"
      sx={{
        position: "absolute",
        left: 0,
        right: 0,
        top: 0,
        bottom: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        opacity: 0,
        transform: "translateY(8px)",
        transition: "opacity 0.2s, transform 0.2s",
        zIndex: 2,
        whiteSpace: "nowrap",
        fontSize: 14,
        fontWeight: 700,
      }}
    >
      {fullLabel}
    </Box>
    {/* For accessibility, show short label as fallback */}
    <Box sx={{ opacity: 0 }}>{shortLabel}</Box>
  </Box>
);
